import { render } from "./ClaimActionButtons.vue?vue&type=template&id=48e487b6&scoped=true"
import script from "./ClaimActionButtons.vue?vue&type=script&lang=js"
export * from "./ClaimActionButtons.vue?vue&type=script&lang=js"

import "./ClaimActionButtons.vue?vue&type=style&index=0&id=48e487b6&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e487b6"]])

export default __exports__